import styled, { StyledComponent } from 'styled-components';

export const SearchFilterPanelWrapper: StyledComponent<'div', any> = styled.div`
  width: 100%;
  height: 44px;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 10px;
  align-items: center;

  color: #494949;
`;

export const FilterBar: StyledComponent<'div', any> = styled.div`
  height: 100%;
  gap: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const FilterControlButton: StyledComponent<'div', any> = styled.div`
  /* height: 100%; */
  /* padding: 0 8px;
  margin-left: 24px; */

  /* display: flex;
  flex-direction: row;
  align-items: center; */
  flex-shrink: 0;

  cursor: pointer;
`;
